import React from "react"
import clsx from "clsx"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import ErrorIcon from "@mui/icons-material/Error"
import InfoIcon from "@mui/icons-material/Info"
import CloseIcon from "@mui/icons-material/Close"
import { amber } from "@mui/material/colors"
import IconButton from "@mui/material/IconButton"
import SnackbarContent from "@mui/material/SnackbarContent"
import WarningIcon from "@mui/icons-material/Warning"
import { styled } from "@mui/material/styles"
import { FormattedMessage } from "react-intl"

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

const StyledSnackbarContent = styled(SnackbarContent, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant }) => ({
  ...(variant === "success" && {
    backgroundColor: "#64B5B5",
    display: "block",
  }),
  ...(variant === "error" && {
    backgroundColor: "#E96F65",
    display: "block",
  }),
  ...(variant === "info" && {
    backgroundColor: theme.palette.primary.main,
    display: "block",
  }),
  ...(variant === "warning" && {
    backgroundColor: amber[700],
    display: "block",
  }),
}))

const iconStyle = {
  fontSize: "20px",
}

const iconVariantStyle = (theme) => ({
  opacity: 0.9,
  marginRight: theme.spacing(1),
})

const messageStyle = {
  display: "flex",
  alignItems: "center",
  whiteSpace: "pre-line",
  justifyContent: "space-between",
}

const SnackbarContentWrapper = React.forwardRef((props, ref) => {
  const { message, onClose, variant } = props
  // eslint-disable-next-line security/detect-object-injection
  const Icon = variantIcon[variant]

  return (
    <StyledSnackbarContent
      ref={ref}
      variant={variant}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" style={messageStyle}>
          <span id="snackbar-message" style={messageStyle}>
            <Icon
              style={{
                ...iconStyle,
                ...iconVariantStyle({ spacing: (v) => 8 * v }),
              }}
            />
            {message === "Snackbar.Success" && (
              <FormattedMessage id="Snackbar.Success" />
            )}
            {message === "Snackbar.Error" && (
              <FormattedMessage id="Snackbar.Error" />
            )}
            {message === "Snackbar.NotFound" && (
              <FormattedMessage id="Snackbar.NotFound" />
            )}
            {message === "Snackbar.Logout" && (
              <FormattedMessage id="Snackbar.Logout" />
            )}
          </span>
          <span id="snackbar-button" style={messageStyle}>
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon style={iconStyle} />
            </IconButton>
          </span>
        </span>
      }
    />
  )
})

export default SnackbarContentWrapper
